import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import newsData from "../data/newsData";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function NewsSection() {
    const { t } = useTranslation();
    useScrollAnimation();
    const showData = newsData.slice(0, 3).map((el, index) =>
        <div key={index} className="w-100 js-scroll fade-btm w-[32%] flex flex-col shadow-[0px_0px_10px_#00000029] rounded-[8px]">
            <div className="w-[100%] border-b-[3px] border-b-[#017E89]">
                <img className="w-full h-full rounded-t-[8px]" src={el.image} alt="" />
            </div>
            <div className="w-[100%] p-[20px] flex flex-col justify-between gap-[15px]">
                <div className="flex flex-col gap-[15px]">
                    <div className="capitalize font-bold text-[20px]">{t(`${el.title}`)}</div>
                    <p>{t(`${el.description.length > 50 ? el.description.substring(0, 100) + "..." : el.description}`)}</p>
                    <div className="flex items-center gap-[5px]">
                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/calender.svg").default} alt="" />
                        <div className="font-bold text-[#017E89]">{el.data}</div>
                    </div>
                </div>
                <Link to={`/newsDetails/${el.id}`}>
                    <span className="capitalize font-bold">Read More</span>
                    <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )
    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col items-center justify-center mx-auto w-fit">
                <div className="js-scroll fade-top w-[90px] h-[30px]">
                    <img className="w-[100%] h-[100%]" src={require("../../assets/icons/lineMainTitle.svg").default} alt="" />
                </div>
                <div className="js-scroll fade-btm text-[35px] font-bold uppercase text-[#017E89]">{t("News & Events")}</div>
                <span className="js-scroll fade-btm w-[50%] bg-[#017E89] h-[3px]"></span>
            </div>
            <div className="container flex flex-col gap-[15px] items-center py-[20px]">
                <div className="f-col flex gap-[15px]">
                    {showData}
                </div>
                <Link className="js-scroll fade-btm bg-[#017E89] w-fit px-[30px] py-[7px] rounded-[4px] text-white font-bold capitalize" to={"/news"}>{t("Show More")}</Link>
            </div>
        </section>
    );
}